







































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Typography from '@/components/Rain/Typography/Typography.vue'
import { Option } from '@/entities/rain/dropdown'
import vClickOutside from 'v-click-outside'

@Component<BaseMenu>({
    components: {
        Typography,
    },
    directives: {
        clickOutside: vClickOutside.directive
    }
})
export default class BaseMenu extends Vue {
    @Prop({ type: String, required: false, default: '' })
    public readonly title!: string
    @Prop({ type: Array, required: false, default: [] })
    public readonly options!: Option[]

    public hideMenu = true

    @Watch('hideMenu')
    public hideMenuChanged() {
        this.hideMenu ? this.$emit('closeMenu') : this.$emit('openMenu')
    }

    public handleClick(option: Option) {
        if (option.disabled) {
            return
        }

        this.hideMenu = true
        this.$emit('select', option)
    }

    /**
     * Handler for when the base menu's content is clicked.
     */
    private handleMenuToggle() {
        this.hideMenu = !this.hideMenu;
        this.$emit('menuDisplayToggled', this.hideMenu);
    }

    /**
     * Handler for mouse clicks outside the base menu.
     */
    private handleClickOutside() {
        this.hideMenu = true;
        this.$emit('menuDisplayToggled', this.hideMenu);
    }

}
